import { getApiClient } from '../services/api';

export enum PositionCode {
  '侧边栏-AI干货-行业趋势报告' = 982560, // done
  '侧边栏-预约产品演示' = 982559, // done
  '侧边栏-微信咨询-企业咨询' = 981033, // done
  '帮助中心-企业服务-资产定制' = 981053, // deprecated
  '有言官网学院-客户案例-合作伙伴' = 982579, // done
  '魔珐有言-应用场景-底部' = 981065, // done
  '有言官网认证失败联系我们' = 981991, // done
  '有言官网认证成功联系我们' = 982585, //done
  '有言官网-企业版即将过期' = 981992,
  '有言官网-企业版已过期' = 982586, // done
  '企业版言币不足' = 981993, // done
  '团队成员提醒言币不足' = 981069, // done
  '企业版-有言官网云存储空间到期' = 981071, // done
  '企业版-有言官网云存储空间不足' = 981072, // done
  '有言官套餐网权益页面专属定制' = 981073, // done
  '有言官网-付费订阅-咨询定制' = 982588, // done
  '有言官网个人空间上传按钮' = 981994, // done
  '有言官网权益管理加购言币' = 982597, // done
  '有言官网付费订阅团队入门' = 981074, // deprecated
  '有言官网-企业咨询' = 1078922, // done
  '企业需求咨询' = 1078924, // done
}

export interface IGetUniqueSubQrcodeParams {
  gclid: string;
  utm_source: string;
  live_code: PositionCode;
  source_from: string;
  source: string;
  sign?: string;
}

export const getUniqueSubQrcode = async (params: IGetUniqueSubQrcodeParams) => {
  const client = await getApiClient();
  return client.get<string>(`/analysis_backend/analysis_center/get_unique_sub_qrcode/`, params);
};
